import styles from './styles.module.scss';
import ReactPlayer from "react-player";

const Vid = (props) => {



    return (
        <div className={`${props.version != "game" && styles[`width--100P`]} ${styles[`height--50P`]}`} 
        >
            

            
       
            
        <ReactPlayer
        url={props.url}
        playing={false} // Autoplay
        controls={true} // Show video controls
       muted={false} // Mute the video (required for many browsers' autoplay)
        loop={true}
        className={`${styles[`videoPlayer`]} ${props.version == "game" && styles[`videoPlayer--game`]}`}
     
      />
      
        </div>
    );
}


export default Vid;